module.exports = __webpack_public_path__ + "static/media/download.9f0cccc1.svg";